export const CLAIM_STATUS_INITIATED = 'Initiated';
export const CLAIM_STATUS_IN_PROGRESS = 'InProgress';
export const CLAIM_STATUS_SUBMITTED = 'Submitted';
export const CLAIM_STATUS_CANCELLED = 'Cancelled';
export const CLAIM_STATUS_EXPIRED = 'Expired';
export const CLAIM_STATUS_DRAFT = 'Draft';
export const CLAIM_STATUS_PROCESSING = 'Processing';
export const CLAIM_STATUS_EXITED = 'Exited';

export const GET_CLAIM_STATUS = {
  Initiated: 'Initiated',
  InProgress: 'In Progress',
  Submitted: 'Submitted',
  Cancelled: 'Cancelled',
  Expired: 'Expired',
  Assisted: 'Assisted',
  Processing: 'Processing',
  Exited: 'Exited',
};

export const GET_CLAIM_STATUS_WHEN_ASSISTED = {
  Draft: 'In Progress',
  Cancelled: 'In Progress',
  Submitted: 'Submitted',
  Processing: 'Processing',
  Assisted: 'Assisted',
  Exited: 'Exited',
};

export const GET_CLAIM_STATUS_FR = {
  Initiated: 'Initiated(fr)',
  InProgress: 'In Progress(fr)',
  Submitted: 'Soumise',
  Cancelled: 'Cancelled(fr)',
  Expired: 'Expired(fr)',
  Assisted: 'Assisted(fr)',
  Processing: 'En traitement',
  Exited: 'Exited(fr)',
};

export const GET_CLAIM_STATUS_WHEN_ASSISTED_FR = {
  Draft: 'In Progress(fr)',
  Cancelled: 'Cancelled(fr)',
  Submitted: 'Soumise',
  Processing: 'En traitement',
  Assisted: 'Assisted(fr)',
  Exited: 'Exited(fr)',
};
